import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    dialogTitleGreen: {
        color: theme.palette.success.main,
        fontWeight: "bold"
    },
    dialogTitleRed: {
        color: theme.palette.error.main,
        fontWeight: "bold"
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        flexWrap: "wrap",
        width: "100%"
    },
    descriptionContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        fontWeight: "lighter",
        borderRadius: 5,
        padding: 10,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        border: "solid 1px",
        marginTop: 10
    },
    infoRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divider: {
        marginLeft: 25,
        marginRight: 25,
        background: 'white',
        width: 1
    },
    hintText: {
        color: theme.palette.common.white,
        marginLeft: 5
    }
}));

export {useStyles};